module.exports = __webpack_public_path__ + "img/womanWave.73958b7a.png";